import { cva } from "class-variance-authority";
import { cn } from "../../lib/utils";

const skeletonVariants = cva("animate-pulse rounded-md bg-primary/10", {
  variants: {
    variant: {
      default: "",
      text: "h-4 w-full",
      title: "h-6 w-2/3",
      avatar: "h-10 w-10 rounded-full",
      card: "h-40 w-full rounded-xl",
      button: "h-9 w-24 rounded-md",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

function Skeleton({ className, variant, ...props }) {
  return (
    <div className={cn(skeletonVariants({ variant }), className)} {...props} />
  );
}

export { Skeleton };
